import React from 'react';
import PropTypes from 'prop-types';
import ErrorDialog from 'components/ErrorDialog';

const PrintErrorDialog = ({
  open,
  closeAction = () => {},
  buttonAction = () => {},
  ...props
}) => {
  return (
    <ErrorDialog
      ariaLabel="Error during printing to a PDF"
      buttonAction={buttonAction}
      buttonText="Try Again"
      closeAction={closeAction}
      description="Sorry, something went wrong while trying to print this content to a PDF. "
      open={open}
      title="Something went wrong."
      {...props}
    />
  );
};

PrintErrorDialog.propTypes = {
  isOpen: PropTypes.bool,
  closeAction: PropTypes.func,
};

export default PrintErrorDialog;
